import { useMemo } from 'react'

import { useAccounts } from '@modules-deprecated/app/accounts'

export const useAccount = (accountId?: string) => {
  const { accounts = [], isLoading } = useAccounts()
  const account = useMemo(() => accounts.find((account) => account.id === accountId), [accounts, accountId])
  return { account, isLoading }
}
